import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardActionArea, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { WHATS_NEW_ENTRY_SOURCE, announcementPath, formatPublishedAt, isFresh } from './constants'
import { NewChip } from './new-chip'
import { PlanChip, UpdateTypeChip } from './update-type-chip'
import { WhatsNewThumbnail } from './whats-new-thumbnail'
import { useRailCardStyles } from './styles'

/**
 * One 300px card, on the Home rail and under a note ("More updates"). The
 * whole card is the link; `source` rides along as `?from=` so the note view
 * knows which of the two it came from.
 */
export const WhatsNewRailCard = ({ announcement, source, dataTest }) => {
  const classes = useRailCardStyles()
  const { id, type, title, publishedAt, planLabel } = announcement

  return (
    <Card className={classes.card} data-test={dataTest}>
      <CardActionArea
        component={RouterLink}
        to={announcementPath(id, source)}
        className={classes.action}
        data-test={`${dataTest}-link`}
      >
        <WhatsNewThumbnail announcement={announcement} width='100%' height={150} />
        <div className={classes.body}>
          <div className={classes.chips}>
            {isFresh(publishedAt) && <NewChip />}
            <UpdateTypeChip type={type} />
            <PlanChip label={planLabel} />
          </div>
          <Typography component='h3' className={classes.title}>{title}</Typography>
          <Typography component='time' dateTime={publishedAt} className={classes.date}>
            {formatPublishedAt(publishedAt)}
          </Typography>
        </div>
      </CardActionArea>
    </Card>
  )
}

WhatsNewRailCard.propTypes = {
  announcement: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    title: PropTypes.string.isRequired,
    publishedAt: PropTypes.string,
    planLabel: PropTypes.string
  }).isRequired,
  source: PropTypes.oneOf(Object.values(WHATS_NEW_ENTRY_SOURCE)).isRequired,
  dataTest: PropTypes.string
}
